
import React from 'react';
import TaskManager from '../tasks/TaskManager';

export const AdminTasksTab: React.FC = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Task Management</h1>
      <p className="text-sm text-gray-500 mb-6">
        Create and monitor tasks for data processing
      </p>
      <TaskManager />
    </div>
  );
};

export default AdminTasksTab;
